<template>
  <v-card class="vacation-decline">
    <v-subheader>
      <v-icon medium color="warning" class="mr-2">card_travel</v-icon>
      {{date}} <span class="ml-2">{{description}}</span>
    </v-subheader>
  </v-card>

</template>

<script>
  export default {
    name: "VacationDecline",
    props: ["date", "description", "level"]
  }
</script>

<style scoped>
  .vacation-decline {
    border: 1px solid #78909C;
  }

</style>